import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, withCtx as _withCtx, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-778b5d5f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hd-citations-module hd-container-content" }
const _hoisted_2 = {
  key: 0,
  class: "hd-citations-module__body"
}
const _hoisted_3 = {
  class: "hd-citations-module__content crux-scroll",
  "data-crux": "citations-scroll-container"
}
const _hoisted_4 = { class: "hd-citations-module__body hd-citations-module__body--overlay" }
const _hoisted_5 = {
  class: "hd-citations-module__content crux-scroll",
  "data-crux": "citations-scroll-container"
}
const _hoisted_6 = { class: "hd-citations-module__body hd-citations-module__body--overlay" }
const _hoisted_7 = {
  class: "hd-citations-module__content crux-scroll",
  "data-crux": "citations-scroll-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_citations_handle = _resolveComponent("citations-handle")!
  const _component_citations_head = _resolveComponent("citations-head")!
  const _component_citations_list = _resolveComponent("citations-list")!
  const _component_citations_unordered = _resolveComponent("citations-unordered")!
  const _component_citations_abbreviations = _resolveComponent("citations-abbreviations")!
  const _component_panel_module = _resolveComponent("panel-module")!
  const _component_overlay_module = _resolveComponent("overlay-module")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
			'hd-citations',
			{ 'is-disabled': _ctx.citations.length === 0 }
		])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.hideHandle)
        ? (_openBlock(), _createBlock(_component_citations_handle, {
            key: 0,
            class: _normalizeClass([
					'crux-click',
					{ 'is-disabled': _ctx.citations.length === 0 }
				]),
            "data-crux": "citations-handle",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.processPanel('citations')))
          }, null, 8, ["class"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.panel === 'citations')
          ? (_openBlock(), _createBlock(_component_panel_module, { key: 0 }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["hd-citations-module__window", { 'is-active': _ctx.panel === 'citations' }])
                }, [
                  _createVNode(_component_citations_handle, {
                    icon: "chevron-down",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.processPanel()))
                  }),
                  (_ctx.activeCitationType)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(_component_citations_head, {
                          citationsType: _ctx.citationsType,
                          activeCitationType: _ctx.activeCitationType,
                          callback: _ctx.makeCitationsActive
                        }, null, 8, ["citationsType", "activeCitationType", "callback"]),
                        _createElementVNode("div", _hoisted_3, [
                          _withDirectives(_createVNode(_component_citations_list, {
                            datum: _ctx.getCitationsContent()
                          }, null, 8, ["datum"]), [
                            [_vShow, _ctx.rendererFunction() === 'CitationsList']
                          ]),
                          _withDirectives(_createVNode(_component_citations_unordered, {
                            datum: _ctx.getCitationsContent()
                          }, null, 8, ["datum"]), [
                            [_vShow, _ctx.rendererFunction() === 'CitationsUnordered']
                          ]),
                          _withDirectives(_createVNode(_component_citations_abbreviations, {
                            datum: _ctx.getCitationsContent()
                          }, null, 8, ["datum"]), [
                            [_vShow, _ctx.rendererFunction() === 'CitationsAbbreviations']
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 2)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (_ctx.citationsType.includes(_ctx.overlay))
          ? (_openBlock(), _createBlock(_component_overlay_module, { key: 0 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _withDirectives(_createVNode(_component_citations_list, {
                      datum: _ctx.getCitationsContent(_ctx.overlay)
                    }, null, 8, ["datum"]), [
                      [_vShow, _ctx.rendererFunctionOverlay() === 'CitationsList']
                    ]),
                    _withDirectives(_createVNode(_component_citations_unordered, {
                      datum: _ctx.getCitationsContent(_ctx.overlay)
                    }, null, 8, ["datum"]), [
                      [_vShow, _ctx.rendererFunctionOverlay() === 'CitationsUnordered']
                    ]),
                    _withDirectives(_createVNode(_component_citations_abbreviations, {
                      datum: _ctx.getCitationsContent(_ctx.overlay)
                    }, null, 8, ["datum"]), [
                      [_vShow, _ctx.rendererFunctionOverlay() === 'CitationsAbbreviations']
                    ])
                  ])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (_ctx.overlay === 'citations')
          ? (_openBlock(), _createBlock(_component_overlay_module, { key: 0 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_citations_head, {
                    citationsType: _ctx.citationsType,
                    activeCitationType: _ctx.activeCitationType,
                    callback: _ctx.makeCitationsActive
                  }, null, 8, ["citationsType", "activeCitationType", "callback"]),
                  _createElementVNode("div", _hoisted_7, [
                    _withDirectives(_createVNode(_component_citations_list, {
                      datum: _ctx.getCitationsContent()
                    }, null, 8, ["datum"]), [
                      [_vShow, _ctx.rendererFunction() === 'CitationsList']
                    ]),
                    _withDirectives(_createVNode(_component_citations_unordered, {
                      datum: _ctx.getCitationsContent()
                    }, null, 8, ["datum"]), [
                      [_vShow, _ctx.rendererFunction() === 'CitationsUnordered']
                    ]),
                    _withDirectives(_createVNode(_component_citations_abbreviations, {
                      datum: _ctx.getCitationsContent()
                    }, null, 8, ["datum"]), [
                      [_vShow, _ctx.rendererFunction() === 'CitationsAbbreviations']
                    ])
                  ])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
}